<template>
  <label
    :class="['ToggleSwitch', { disabled }, { isLegend }]"
  >
    <span
      v-if="label"
      class="label"
    >{{ label }}</span>
    <input
      v-model="localValue"
      :disabled="disabled"
      type="checkbox"
      @change="$event => handleChange($event.target.checked)"
    >
    <span class="slider round success" />
  </label>
</template>

<script>

export default {
  // Component mounted from mapbox.js as instance.$el //
  name: 'Toggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bgColor: null,
    isLegend: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      localValue: false,
    }
  },
  created () {
    this.localValue = this.value
  },
  methods: {
    handleChange (value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss">

/* The switch - the box around the slider */
.ToggleSwitch {
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 30px;
  height: 17px;
  margin-bottom: 0;

  /* Hide default HTML checkbox */
  input {
    display: none;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;

    &:after {
      position: absolute;
      content: "";
      height: 13px;
      width: 13px;
      left: 2px;
      bottom: 2px;
      background-color: white;
      -webkit-transition: .4s;
      transition: .4s;
    }

    /* Rounded sliders */
    &.round {
      border-radius: 17px;

      &:after {
        border-radius: 50%;
      }
    }
  }

  input {
    &:checked + .slider {
      &.default {
        background-color: #444;
      }
      &.primary {
        background-color: #2196F3;
      }
      &.success {
        background-color: #8bc34a;
      }
      &.info {
        background-color: #3de0f5;
      }
      &.warning {
        background-color: #FFC107;
      }
      &.danger {
        background-color: #f44336;
      }
    }
    &:focus + .slider {
      box-shadow: 0 0 1px #2196F3;
    }
    &:checked + .slider:after {
      transform: translateX(13px);
    }
  }


  &.disabled {
    .slider {
      cursor: not-allowed;
      opacity: 0.6;
    }


  }
  &.layer-category {
    transform: scale(0.8) translateY(3px);
  }
  &.isLegend {
    margin-left: -1.2rem;
    margin-right: 0.5rem;
  }

  .label {
    white-space: nowrap;
    margin-left: 2.5em;
  }
}
</style>
